import { ReactNode } from 'react';

interface BadgeProps {
    children?: ReactNode;
    variant?: 'danger' | 'warning' | 'success' | 'info';
    size?: 'sm' | 'md';
}

const Badge = ({ children, variant = 'danger', size = 'sm' }: BadgeProps) => {
    const getVariantStyles = () => {
        switch (variant) {
            case 'danger':
                return { backgroundColor: '#dc3545', color: 'white' };
            case 'warning':
                return { backgroundColor: '#ffc107', color: '#212529' };
            case 'success':
                return { backgroundColor: '#198754', color: 'white' };
            case 'info':
                return { backgroundColor: '#0dcaf0', color: '#212529' };
            default:
                return { backgroundColor: '#dc3545', color: 'white' };
        }
    };

    const getSizeStyles = () => {
        switch (size) {
            case 'sm':
                return { fontSize: '11px', padding: '3px 6px', minWidth: '18px', height: '18px' };
            case 'md':
                return { fontSize: '12px', padding: '4px 8px', minWidth: '20px', height: '20px' };
            default:
                return { fontSize: '11px', padding: '3px 6px', minWidth: '18px', height: '18px' };
        }
    };

    return (
        <span
            style={{
                marginLeft: '8px',
                borderRadius: '50%',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600',
                lineHeight: '1',
                ...getVariantStyles(),
                ...getSizeStyles(),
            }}
        >
            {children}
        </span>
    );
};

export default Badge;
